import { render } from "./single-card.vue?vue&type=template&id=99859bfc"
import script from "./single-card.vue?vue&type=script&lang=js"
export * from "./single-card.vue?vue&type=script&lang=js"

import "./single-card.vue?vue&type=style&index=0&id=99859bfc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__